import styled from 'styled-components';
import { Button } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.color.sidebarBorder};
  background-color: white;
  padding: 20px;
  border-radius: 4px;
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ContainerButtons = styled.div`
  display:flex;
`;

export const ButtonMerge = styled(Button)`
  &&.ui.button {
    cursor: ${({ notAllowed }) => (notAllowed && 'not-allowed')};
    pointer-events: auto !important;
  }
`;

export const ButtonUnmerge = styled(Button.Inverted)`
  &&.ui.button {
    margin-right: 20px;
    cursor: ${({ notAllowed }) => (notAllowed && 'not-allowed')};
    pointer-events: auto !important;
  }
`;
